import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import './Table.scss';
export const Table = ({ children, isClickable, isHoverable }) => (_jsx("table", { className: classNames({
        'sg-table': true,
        'sg-table-clickable': isClickable,
        'sg-table-hoverable': isHoverable,
    }), children: children }));
//# sourceMappingURL=Table.js.map